export default __webpack_public_path__ + "static/media/light_dark.a5972291.svg";